import Vue from 'vue'

export function initPrototype(i18n) {
    const locale = {
        firstDayOfWeek: 1,
        dayNames: [
            i18n.tc('calendar.dayNames.sunday'),
            i18n.tc('calendar.dayNames.monday'),
            i18n.tc('calendar.dayNames.tuesday'),
            i18n.tc('calendar.dayNames.wednesday'),
            i18n.tc('calendar.dayNames.thursday'),
            i18n.tc('calendar.dayNames.friday'),
            i18n.tc('calendar.dayNames.saturday')
        ],
        dayNamesShort: [
            i18n.tc('calendar.dayNamesShort.sunday'),
            i18n.tc('calendar.dayNamesShort.monday'),
            i18n.tc('calendar.dayNamesShort.tuesday'),
            i18n.tc('calendar.dayNamesShort.wednesday'),
            i18n.tc('calendar.dayNamesShort.thursday'),
            i18n.tc('calendar.dayNamesShort.friday'),
            i18n.tc('calendar.dayNamesShort.saturday')
        ],
        dayNamesMin: [
            i18n.tc('calendar.dayNamesShort.sunday'),
            i18n.tc('calendar.dayNamesShort.monday'),
            i18n.tc('calendar.dayNamesShort.tuesday'),
            i18n.tc('calendar.dayNamesShort.wednesday'),
            i18n.tc('calendar.dayNamesShort.thursday'),
            i18n.tc('calendar.dayNamesShort.friday'),
            i18n.tc('calendar.dayNamesShort.saturday')
        ],
        monthNames: [
            i18n.tc('calendar.monthNames.january'),
            i18n.tc('calendar.monthNames.february'),
            i18n.tc('calendar.monthNames.march'),
            i18n.tc('calendar.monthNames.april'),
            i18n.tc('calendar.monthNames.may'),
            i18n.tc('calendar.monthNames.june'),
            i18n.tc('calendar.monthNames.july'),
            i18n.tc('calendar.monthNames.august'),
            i18n.tc('calendar.monthNames.september'),
            i18n.tc('calendar.monthNames.october'),
            i18n.tc('calendar.monthNames.november'),
            i18n.tc('calendar.monthNames.december')
        ],
        monthNamesShort: [
            i18n.tc('calendar.monthNames.january'),
            i18n.tc('calendar.monthNames.february'),
            i18n.tc('calendar.monthNames.march'),
            i18n.tc('calendar.monthNames.april'),
            i18n.tc('calendar.monthNames.may'),
            i18n.tc('calendar.monthNames.june'),
            i18n.tc('calendar.monthNames.july'),
            i18n.tc('calendar.monthNames.august'),
            i18n.tc('calendar.monthNames.september'),
            i18n.tc('calendar.monthNames.october'),
            i18n.tc('calendar.monthNames.november'),
            i18n.tc('calendar.monthNames.december')
        ],
        dateFormat: 'dd.mm.yy',
        weekHeader: i18n.tc('calendar.weekHeader'),
        today: i18n.tc('calendar.today'),
        clear: i18n.tc('calendar.clear')
    }
    Vue.prototype.$primevue.config.locale = locale
}
